const reOpenTag =
  /<(\w[\w-]*)((?:\s+\w[\w-]*(?:=(?:"[^"]*"|'[^']*'))?)*)\s*\/?>/g
const reCloseTag = /<\/(\w[\w-]*)>/g
const reTagAttribute = /(?:\s+(\w[\w-]*)(?:=(?:"([^"]*)"|'([^']*)'))?)/g

export default {
  install(Vue) {
    Vue.prototype.$sanitizeHtml = (
      value,
      options = {
        whiteList: {
          tags: [
            'a',
            'abbr',
            'address',
            'article',
            'aside',
            'b',
            'bdi',
            'bdo',
            'blockquote',
            'br',
            'caption',
            'cite',
            'code',
            'col',
            'colgroup',
            'data',
            'dd',
            'dfn',
            'div',
            'dl',
            'dt',
            'em',
            'figcaption',
            'figure',
            'footer',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'header',
            'hgroup',
            'hr',
            'i',
            'kbd',
            'li',
            'main',
            'main',
            'mark',
            'nav',
            'ol',
            'p',
            'pre',
            'q',
            'rb',
            'rp',
            'rt',
            'rtc',
            'ruby',
            's',
            'samp',
            'section',
            'small',
            'span',
            'strong',
            'sub',
            'sup',
            'table',
            'tbody',
            'td',
            'tfoot',
            'th',
            'thead',
            'time',
            'tr',
            'u',
            'ul',
            'var',
            'wbr'
          ],
          attributes: {
            a: ['href', 'name', 'target'],
            img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading']
          }
        },
        strategy: 'escape', // "escape" | "remove",
        javaScriptAnchors: false
      }
    ) => {
      const {
        strategy,
        whiteList: { tags, attributes },
        javaScriptAnchors
      } = options

      return value
        .replace(reOpenTag, (openTag, tagName) => {
          if (tags.includes(tagName)) {
            return openTag.replace(
              reTagAttribute,
              (match, attributeName, attributeValue) => {
                if (
                  !javaScriptAnchors &&
                  tagName === 'a' &&
                  /^javascript:/i.test(attributeValue)
                ) {
                  return ''
                }

                const allowedAttributes = attributes[tagName]

                if (Array.isArray(allowedAttributes)) {
                  return allowedAttributes.includes(attributeName) ? match : ''
                }

                return ''
              }
            )
          }

          return strategy === 'escape'
            ? openTag.replace(/^</, '&lt;').replace(/>$/, '&gt;')
            : ''
        })
        .replace(reCloseTag, (closeTag, tagName) => {
          if (tags.includes(tagName)) {
            return closeTag
          }

          return strategy === 'escape'
            ? closeTag.replace(/^</, '&lt;').replace(/>$/, '&gt;')
            : ''
        })
    }
  }
}
